import { Button, Container, Group, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import classes from "./ErrorContent.module.css";

type ErrorContentProps = {
  statusCode: number;
  title: string;
  description: string;
};

const ErrorContent: React.FC<ErrorContentProps> = ({
  statusCode,
  title,
  description,
}) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <Container className={classes.root}>
      <div className={classes.label}>{statusCode}</div>
      <Title className={classes.title}>{title}</Title>
      <Text c="dimmed" size="lg" ta="center" className={classes.description}>
        {description}
      </Text>
      <Group justify="center">
        <Button variant="subtle" size="md" onClick={handleBackToHome}>
          {t("button.backToHome")}
        </Button>
      </Group>
    </Container>
  );
};

export default ErrorContent;
